import React, { useState, useEffect } from 'react';

import './styles.css';

import { useParams } from 'react-router';
import { useHistory } from 'react-router';

import loadTextTest from '../../../functions/loadTextTest';

import studentsServices from '../../../services/academy/studentsServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import Input from '../../../components/Input';
import ActivityIndicator from '../../../components/ActivityIndicator';
import PopupNewPassword from '../../../components/PopupNewPassword';
import cepServices from '../../../services/cepServices';

function EditStudent(props) {
    const params = useParams();
    const history = useHistory();
    const [fetching, setFetching] = useState(true);
    const [studentInfos, setStudentInfos] = useState({});
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [parentName, setParentName] = useState('');
    const [parentSurname, setParentSurname] = useState('');
    const [photo, setPhoto] = useState(null);
    const [postalCode, setPostalCode] = useState('');
    const [addressState, setAddressState] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [district, setDistrict] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [iso2, setIso2] = useState('');
    const [dialCode, setDialCode] = useState('');
    const [phone, setPhone] = useState('');
    const [isValidNumber, setIsValidNumber] = useState('');
    const [birth, setBirth] = useState('');

    const [visibility, setVisibility] = useState(false);

    const [isAdmin, setIsAdmin] = useState(false);



    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));
        
    }


    useEffect(() => {
        verifyIsAdmin();
        readStudentInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function readStudentInfos() {
        const response = await studentsServices.getStudentInfos(params.id);
        setFetching(false);
        if (response.status === 200) {
            const data = response.data;
            setStudentInfos(data);
            setName(data.nome);
            setSurname(data.sobrenome);
            setParentName(data.nome_responsavel);
            setParentSurname(data.sobrenome_responsavel);
            setPhoto(data.foto);
            setPostalCode(data.cep);
            setAddressState(data.estado);
            setCity(data.cidade);
            setAddress(data.logradouro);
            setDistrict(data.bairro);
            setEmail(data.user.email);
            setIso2(data.iso2_ddi);
            setDialCode(data.ddi);
            setPhone(data.telefone);
            setBirth(data.data_nascimento);
        } else
            alert("Erro ao ler informações do estudante, tente novamente!");
    }

    async function updateStudentInfos() {
        if(password != confirmPassword) {
            alert("Os campos de senha e confirmação de senha devem ser iguais.");
            return;
        }
        if (name && surname && parentName && parentSurname && postalCode && addressState && city && address && district && iso2 && dialCode && phone && birth && email) {
            if (isValidNumber) {
                const response = await studentsServices.patchStudentInfos(params.id, email, password,name, surname, parentName, parentSurname ,birth, iso2, dialCode, phone, address, city, district, addressState, postalCode, photo);
                if (response.status === 200)
                    history.goBack();
                else
                    alert("Erro ao editar aluno, tente novamente!");
            } else
                alert(`O número de telefone ${phone} não é válido, tente novamente!`);
        } else
            alert("Preencha os dados obrigatórios*");
    }

    async function getCepInfo() {
        try {
            if(postalCode === "")
                return;
            const response = await cepServices.getCepInfo(postalCode);
            if(response.data.erro)
                alert("Não foi possível encotrar o CEP informado.");
            else {
                setCity(response.data.localidade);
                setAddress(response.data.logradouro);
                setDistrict(response.data.bairro);
                setAddressState(response.data.uf);
            }
        } catch(err) {

            alert("CEP Inválido.");
        }
    }

    useEffect(() => {
        if(postalCode.length === 8)
            getCepInfo();

    }, [postalCode]);

    return (
        <MainView currentPage={isAdmin ? 'academies' : 'students'} adminMenu={isAdmin} coachMenu={props.coachMode}>
            <NavHistory navPages={['Alunos', loadTextTest(studentInfos.nome), 'Editar']} />
            <form className='edit-student-page-form' action="">
                <h4>Edição de aluno</h4>
                {
                    fetching ?
                        <ActivityIndicator /> :
                        <>
                            <Input
                                label='Nome*'
                                placeholder="Nome"
                                id='edit-student-form-name'
                                onChange={(event) => setName(event.target.value)}
                                value={name}
                            />
                            <Input
                                label='Sobrenome*'
                                placeholder="Sobrenome"
                                id='edit-student-form-surname'
                                onChange={(event) => setSurname(event.target.value)}
                                value={surname}
                            />
                            <Input
                                label='Nome do Reponsável*'
                                placeholder="Nome"
                                id='edit-student-form-parent-name'
                                onChange={(event) => setParentName(event.target.value)}
                                value={parentName}
                            />
                            <Input
                                label='Sobrenome do Responsável*'
                                placeholder="Sobrenome"
                                id='edit-student-form-parent-surname'
                                onChange={(event) => setParentSurname(event.target.value)}
                                value={parentSurname}
                            />
                            <Input
                                label='Foto de perfil'
                                type='photo'
                                accept="image/*"
                                placeholder="Selecione uma foto"
                                showFileLabel
                                filePreview
                                className='edit-student-form-file-input'
                                id='edit-student-form-photo'
                                onChange={setPhoto}
                                value={photo ? (typeof photo === "string" ? photo : URL.createObjectURL(photo)) : ''}
                            />
                            <Input
                                label='Código postal (CEP)*'
                                placeholder="Código postal"
                                id='edit-student-form-postal-code'
                                onChange={(event) => setPostalCode(String(event.target.value).replace(/\D/g, ''))}
                                value={postalCode}
                                //onBlur={getCepInfo}
                            />
                            <Input
                                label='Estado*'
                                placeholder="Estado"
                                id='edit-student-form-state'
                                onChange={(event) => setAddressState(event.target.value)}
                                value={addressState}
                            />
                            <Input
                                label='Cidade*'
                                placeholder="Cidade"
                                id='edit-student-form-city'
                                onChange={(event) => setCity(event.target.value)}
                                value={city}
                            />
                            <Input
                                label='Endereço*'
                                placeholder="Endereço"
                                id='edit-student-form-address'
                                onChange={(event) => setAddress(event.target.value)}
                                value={address}
                            />
                            <Input
                                label='Bairro*'
                                placeholder="Bairro"
                                id='edit-student-form-district'
                                onChange={(event) => setDistrict(event.target.value)}
                                value={district}
                            />
                            <Input
                                label='Telefone do Responsável*'
                                type='tel'
                                placeholder="Telefone"
                                id='edit-student-form-phone'
                                onChange={(event) => setPhone(event.target.value)}
                                iso2={iso2}
                                setIso2={setIso2}
                                setDialCode={setDialCode}
                                setIsValidNumber={setIsValidNumber}
                                value={phone}
                            />
                            <Input
                                label='Data de nascimento*'
                                type='date'
                                placeholder="Data de nascimento"
                                id='edit-student-form-birth'
                                onChange={(event) => setBirth(event.target.value)}
                                value={birth}
                            />
                            <Input
                                label='Email*'
                                type='email'
                                placeholder="Email"
                                id='new-student-form-email'
                                onChange={(event) => setEmail(event.target.value)}
                                value={email}
                            />
                            <button className="edit-student-password-button" onClick={(e) => {
                                e.preventDefault();
                                setVisibility(true);
                                }}
                            >
                                Editar Senha
                            </button>
                            <PopupNewPassword
                                visibility={visibility}
                                setVisibility={setVisibility}
                                password={password}
                                confirmPassword={confirmPassword}
                                setPassword={setPassword}
                                setConfirmPassword={setConfirmPassword}
                                onClick={() => setVisibility(false)}
                                buttonTitle="Fechar"
                            />
                            <button type='button' onClick={updateStudentInfos}>Salvar alterações</button>
                        </>
                }
            </form>
        </MainView>

    )
}

export default EditStudent;